import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatGridListModule } from '@angular/material/grid-list';
import { ListDisplayStudentModule } from '../../list-display/list-display-student/list-display-student.module';
import { ListSearchModule } from '../../list-search/list-search.module';
import { SharedServicesModule } from './../../../../shared/services/shared.services.module';
import { PostsecondaryMadLib } from './postsecondary-mad-lib.component';

@NgModule({
  declarations: [PostsecondaryMadLib],
  imports: [
    SharedServicesModule,
    CommonModule,
    MatExpansionModule,
    MatSelectModule,
    MatGridListModule,
    FormsModule,
    ListDisplayStudentModule,
    MatMenuModule,
    ListSearchModule,
  ],
  exports: [PostsecondaryMadLib],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class PostsecondaryMadLibModule {
  /** */
}
